import React from 'react'
import MaterialSymbol from '../material-symbol'

const Group = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="group" {...props} />
))

Group.displayName = 'Group'

export default Group
